import { useMutation } from "@apollo/client";
import {
  Button,
  Center,
  Flex,
  Heading,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CHECK_PAY } from "../../services/graphql/mutation/MercadoPago";
import { ContextApp } from "../../shared/ContextApp";
import { MessageError } from "../../shared/MessageError";
import { useNavigate } from "react-router";
import { BsCart4 } from "react-icons/bs";
import { FiHome } from "react-icons/fi";
import { useCheckUser } from "../../services/hooks/useCheckUser";

export const PaySuccess = () => {
  useCheckUser();
  const { addressIdForBuy } = useContext(ContextApp);
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const [statusCheckPay, setStatusCheckPay] = useState<string>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [checkPay] = useMutation(CHECK_PAY);
  useEffect(() => {
    const address_id = localStorage.getItem("address_id");
    if (searchParams && address_id) {
      setLoading(true);
      checkPay({
        variables: {
          input: {
            address_id: Number(address_id),
            payment_id: searchParams.get("payment_id"),
          },
        },
      })
        .then((data) => {
          const { checkPay } = data.data;
          const { status } = checkPay;
          setStatusCheckPay(status);
          localStorage.removeItem("address_id");
        })
        .catch((error) => {
          toast({
            duration: 2500,
            position: "top",
            render: () =>
              MessageError(
                "Hubo un error al registrar la venta. Por favor contactate con algún vendedor."
              ),
          });
          localStorage.removeItem("address_id");
          navigate("/cart");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      toast({
        duration: 2500,
        position: "top",
        render: () =>
          MessageError(
            "No se especificó ninguna dirección para que le enviemos el producto."
          ),
      });
      navigate("/cart");
    }
  }, [searchParams, addressIdForBuy]);

  return (
    <>
      {loading ? (
        <>
          <Center>
            <Spinner />
          </Center>
        </>
      ) : (
        <>
          {statusCheckPay === "Success" ? (
            <>
              <Center
                display={"flex"}
                flexDirection="column"
                textAlign={"center"}
              >
                <Heading mb={3} as="h4">
                  Ya registramos tu compra!
                </Heading>
                <Flex flexDirection={{ base: "column", sm: "row" }}>
                  <Button
                    mb={{ base: "10px", sm: "0px" }}
                    mr={{ base: "0px", sm: "10px" }}
                    leftIcon={<FiHome />}
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    Ir al inicio
                  </Button>
                  <Button
                    leftIcon={<BsCart4 />}
                    onClick={() => {
                      navigate("/buys");
                    }}
                  >
                    Ir a ver tus compras
                  </Button>
                </Flex>
              </Center>
            </>
          ) : null}
        </>
      )}
    </>
  );
};
